import React from 'react';

const IconHex = () => (
  // <svg id="hex" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
  //   <title>Hexagon</title>
  //   <g transform="translate(-8.000000, -2.000000)">
  //     <g transform="translate(11.000000, 5.000000)">
  //       <polygon
  //         stroke="currentColor"
  //         strokeWidth="5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         points="39 0 0 22 0 67 39 90 78 68 78 23"
  //         fill="currentColor"
  //       />
  //     </g>
  //   </g>
  // </svg>
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        {/* <!-- Hexagon --> */}
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        {/* <!-- Letter K --> */}
        <path
          d="M30 30 L30 60 L38 60 L38 45 L50 60 L55 60 L42 45 L55 30 L50 30 L38 43 L38 30 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconHex;
